__turbopack_context__.v({
  "className": "ibm_plex_sans_arabic_756ae945-module__Mr2BfW__className",
});
